export const MODULES = {
  AUTH: 'pzzl_auth',
  DOCUMENTS: 'pzzl_document',
  EVENTS: 'pzzl_events',
  FAQ: 'pzzl_faq',
  NEWS: 'pzzl_news',
  NEWSLETTER: 'pzzl_newsletter',
  NOTIFICATIONS: 'pzzl_notification',
  PUBLIC_SITE: 'pzzl_public_site',
};
